// app 1.3.22 (14 Oct 2026) — the short domain M prints on links.
//
// The app and its passkeys live on globalmoneyapp.com (Circle's passkey domain:
// a passkey is bound to one domain, and Circle's RP verifier refuses an
// assertion from any other origin, Related Origin Requests included — tested
// 14 Oct). mdrop.it is the short name: every request to it is a 301 at
// Cloudflare's edge to the same path on globalmoneyapp.com, query kept, and the
// browser carries a #fragment across on its own — so a note link with its code
// after # still opens. m.app will forward the same way when it lands.
//
// Links M shares (notes, pay-by-name, invites) carry the short domain; the app
// itself always runs on location.origin. Nothing here is a security boundary.
export const LINK_ORIGIN = "https://mdrop.it";
